import { useCallback } from "react";
import { useBeforeUnload } from "react-router-dom";

/**
 * Warns on tab close / refresh while `active` (BrowserRouter does not support
 * `usePrompt` / in-app navigation blocking without migrating to `createBrowserRouter`).
 * @param {boolean} active
 */
export function useFormSubmitGuard(active) {
  const onBeforeUnload = useCallback(
    (event) => {
      if (!active) return;
      event.preventDefault();
      event.returnValue = "";
    },
    [active]
  );
  useBeforeUnload(onBeforeUnload);
}
